import React, { useEffect } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { viewImage } from '../../CommonUtils/viewImage';
import * as Yup from 'yup';
import allowNumbersOnly, { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { FaEye } from 'react-icons/fa';
import { useState } from 'react';

export default function AffliationCollegeFaciltiesForm() {
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const validationSchema = Yup.object({
        playgroundAvail: Yup.string().required(ERROR_MSG).nullable(),
        playgroundDistance: Yup.string().required(ERROR_MSG).nullable(),
        playgroundTieup: Yup.string().required(ERROR_MSG).nullable(),
        totalBuiltupArea: Yup.string().required(ERROR_MSG).nullable(),
        playgroundArea: Yup.string().required(ERROR_MSG).nullable(),
        transportFacilityAvail: Yup.string().required(ERROR_MSG).nullable(),
        builtupArea20Percent: Yup.string().required(ERROR_MSG).nullable(),
        parkingArea: Yup.string().required(ERROR_MSG).nullable(),
        parkingProvided: Yup.string().required(ERROR_MSG).nullable(),
        parkingAreaDocument: Yup.string().required(ERROR_MSG).nullable(),
        biometricAdoptedForStudentsUgPg: Yup.string().required(ERROR_MSG).nullable(),
        biometricAdoptedForTeachingNon: Yup.string().required(ERROR_MSG).nullable(),
        noToiletsProvided: Yup.string().required(ERROR_MSG).nullable(),
        separateFemaleToilets: Yup.string().required(ERROR_MSG).nullable(),
        girlsCommonroom: Yup.string().required(ERROR_MSG).nullable(),

        tieupDocument: Yup.string().when('playgroundTieup', {
            is: 'true',
            then: Yup.string().required(ERROR_MSG).nullable(),
            otherwise: Yup.string().nullable(),
        }),


    })
    const soclandalloFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            playgroundAvail: "",
            playgroundDistance: "",
            playgroundTieup: "",
            tieupDocument: "",
            playgroundArea: "",
            transportFacilityAvail: "",
            totalBuiltupArea: "",
            builtupArea20Percent: "",
            parkingArea: "",
            parkingProvided: "",
            parkingAreaDocument: "",
            biometricAdoptedForStudentsUgPg: "",
            biometricAdoptedForTeachingNon: "",
            noToiletsProvided: "",
            noToilets: "",
            separateFemaleToilets: "",
            girlsCommonroom: "",
            totalintake: ""
        },
        validationSchema: validationSchema,


        onSubmit: (values) => {
            const updatedValues = {
                ...values,
                playgroundAvail: values.playgroundAvail,
                playgroundDistance: values.playgroundDistance,
                tieupDocument: values.tieupDocument,
                playgroundArea: parseInt(values.playgroundArea),
                transportFacilityAvail: values.transportFacilityAvail,
                totalBuiltupArea: parseInt(values.totalBuiltupArea),
                builtupArea20Percent: parseInt(values.builtupArea20Percent),
                parkingArea: parseInt(values.parkingArea),
                parkingProvided: values.parkingProvided,
                parkingAreaDocument: values.parkingAreaDocument,
                biometricAdoptedForStudentsUgPg: values.biometricAdoptedForStudentsUgPg,
                biometricAdoptedForTeachingNon: values.biometricAdoptedForTeachingNon,
                noToiletsProvided: parseInt(values.noToiletsProvided),
                noToilets: parseInt(values.noToilets),
                separateFemaleToilets: values.separateFemaleToilets,
                girlsCommonroom: values.girlsCommonroom,
            };
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}AffliationCollegeFaciltiesForm`;
                    CommonAxiosPost(url, updatedValues).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    });
    const [intake, setintake] = useState('')
    function GetFacilitiesData() {
        let url = config.url.API_URL + `getAffliationCollegeFaciltiesReport`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const OtherfacilitiesData = (res?.data?.AffliationCollegeFaciltiesReport[0]);
                setintake(OtherfacilitiesData?.total_approved_intake)
                soclandalloFormik?.setFieldValue("playgroundAvail", OtherfacilitiesData?.playground_avail);
                soclandalloFormik?.setFieldValue("playgroundDistance", OtherfacilitiesData?.playground_distance);
                soclandalloFormik?.setFieldValue("playgroundTieup", OtherfacilitiesData?.playground_tieup?.toString() ?? '');
                soclandalloFormik?.setFieldValue("tieupDocument", OtherfacilitiesData?.tieup_document);
                soclandalloFormik?.setFieldValue("playgroundArea", OtherfacilitiesData?.parking_area);
                soclandalloFormik?.setFieldValue("transportFacilityAvail", OtherfacilitiesData?.transport_facility_avail?.toString() ?? '');
                soclandalloFormik?.setFieldValue("totalBuiltupArea", OtherfacilitiesData?.total_builtup_area);
                soclandalloFormik?.setFieldValue("builtupArea20Percent", OtherfacilitiesData?.builtup_area_20percent);
                soclandalloFormik?.setFieldValue("parkingArea", OtherfacilitiesData?.parking_area);
                soclandalloFormik?.setFieldValue("parkingProvided", OtherfacilitiesData?.parking_provided);
                soclandalloFormik?.setFieldValue("parkingAreaDocument", OtherfacilitiesData?.parking_area_document);
                soclandalloFormik?.setFieldValue("biometricAdoptedForStudentsUgPg", OtherfacilitiesData?.biometric_adopted__for_students_ug_pg?.toString() ?? '');
                soclandalloFormik?.setFieldValue("biometricAdoptedForTeachingNon", OtherfacilitiesData?.biometric_adopted_for_teaching_non?.toString() ?? '');
                soclandalloFormik?.setFieldValue("noToiletsProvided", OtherfacilitiesData?.no_toilets_provided);
                soclandalloFormik?.setFieldValue("noToilets", OtherfacilitiesData?.no_toilets);
                soclandalloFormik?.setFieldValue("separateFemaleToilets", OtherfacilitiesData?.seperate_female_toilets?.toString() ?? '');
                soclandalloFormik?.setFieldValue("girlsCommonroom", OtherfacilitiesData?.girls_commonroom?.toString() ?? '');
                soclandalloFormik?.setFieldValue("totalintake", OtherfacilitiesData?.total_approved_intake);

            } else {
                console.log("Data not Found")
            }
        })
    }
    useEffect(() => {
        GetFacilitiesData();

    }, [])
    // function CalculateTotalIntake(toiletsnum) {
    //     const approvedintakecal = intake / toiletsnum

    //     soclandalloFormik?.setFieldValue("noToilets", approvedintakecal.toFixed(2))
    // }
    function CalculateTotalIntake(toiletsnum) {
        const validToiletsNum = parseFloat(toiletsnum);
        if (isNaN(validToiletsNum) || validToiletsNum === 0) {
            soclandalloFormik?.setFieldValue("noToilets", "0");
            return;
        }

        const approvedintakecal = intake / validToiletsNum;

        const formattedResult = approvedintakecal.toFixed(2);

        soclandalloFormik?.setFieldValue("noToilets", formattedResult);
    }

    return (

        <>
            <CommonFormHeading heading="Facilities" />
            <bie.Container fluid className="px-1" >

                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">

                    <FormikProvider value={soclandalloFormik}>
                        <Form onChange={soclandalloFormik.handleChange} onSubmit={soclandalloFormik.handleSubmit}>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0"> Playground Facility</h1></div>
                            <bie.Row className="px-2 pt-3 m-0">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Playground for Games/Recreation for Students available in</b></label>
                                        <Field as='select' name="playgroundAvail" className='form-control mb-2 mt-3'>
                                            <option value="">--Select--</option>
                                            <option value="Within Own Premises">Within Own Premises</option>
                                            <option value="Outside the College premises">Outside the College premises</option>
                                        </Field>
                                        <ErrorMessage name="playgroundAvail" component="div" className="text-error" />

                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Is the Playground provided at what distance from the college premises</b></label>
                                        <Field as='select' name="playgroundDistance" className='form-control mb-2 mt-3'>
                                            <option value="">--Select--</option>
                                            <option value="Within 5 Kms">Within 5 Kms</option>
                                            <option value="Above 5 Kms">Above 5 Kms</option>
                                        </Field>
                                        <ErrorMessage name="playgroundDistance" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Is there tie up with Municipal Authorities / other Educational Institutions /Any other agency for Playground</b></label>
                                        <Field type="radio" name="playgroundTieup" value="true" onChange={(e) => { soclandalloFormik?.setFieldValue("tieupDocument", '') }} />&nbsp;Yes&emsp;
                                        <Field type="radio" name="playgroundTieup" value="false" />&nbsp; No
                                        <ErrorMessage name="playgroundTieup" component="div" className="text-error" />

                                    </bie.Col>
                                    {soclandalloFormik?.values?.playgroundTieup === "true" ? (<>
                                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                            <label className='mb-1' ><b className='field-mandatory'>Upload relevant documentary evidence for tie-up (Pdf) </b></label>
                                            <div className='d-flex align-items-center'>
                                                <input type="file" className="form-control mt-3 mb-2" name="tieupDocument" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let fileVal = userId + "_" + acYear;
                                                        let filename = fileVal + "tieupDocument"
                                                        let path = "/Uploads/PlaygroundTieupDocument/"
                                                        ImagePdfBucket(e, soclandalloFormik, path, "tieupDocument", filename, "pdf")
                                                    }}
                                                />
                                                {soclandalloFormik.values.tieupDocument && <button type='button' className='ms-2 btn btn-primary' s
                                                    onClick={() => { viewImage(soclandalloFormik.values.tieupDocument) }}><FaEye size={23} /></button>}

                                                <ErrorMessage name="tieupDocument" component="div" className="text-error" />
                                            </div>
                                        </bie.Col>


                                    </>) : (<></>)}
                                </bie.Row>
                                <bie.Row>
                                </bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <label className='mb-1' ><b className='field-mandatory'>Area provided for playground (in Sq. Mtr) </b></label>
                                    <Field type="text" name="playgroundArea" className="form-control mb-2 mt-3"
                                        onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { AllowFloats(e); }} />

                                    <ErrorMessage name="playgroundArea" component="div" className="text-error" />

                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                    <label className='mb-1' ><b className='field-mandatory'>Is Transport facility arranged for students to reach the Playground </b></label>
                                    <div className='form-control mb-2'>
                                        <Field type="radio" name="transportFacilityAvail" value="true" />&nbsp;Yes&emsp;
                                        <Field type="radio" name="transportFacilityAvail" value="false" />&nbsp; No

                                        <ErrorMessage name="transportFacilityAvail" component="div" className="text-error" />
                                    </div>
                                </bie.Col>
                            </bie.Row>

                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Parking Facility</h1></div>

                            <bie.Row className="px-2 my-3">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Total Built up Area of the college (Sq. Mtr)</b></label>

                                        <Field type='text' name="totalBuiltupArea" className='form-control mb-2'
                                            onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { AllowFloats(e); }} />

                                        <ErrorMessage name="totalBuiltupArea" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>20 % of Built up Area (Sq. Mtr) </b></label>

                                        <Field type='text' name="builtupArea20Percent" className='form-control mb-2'
                                            onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { AllowFloats(e); }}
                                        />

                                        <ErrorMessage name="builtupArea20Percent" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Parking Area provided (Sq. Mtr)</b></label>

                                        <Field type='text' name="parkingArea" className="form-control" maxLength="6"
                                            onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { AllowFloats(e); }} />

                                        <ErrorMessage name="parkingArea" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Parking Area provided </b></label>

                                        <Field as='select' name="parkingProvided" className='form-control mb-2'>
                                            <option value="">--Select--</option>
                                            <option value="Within college premises">Within college premises</option>
                                            <option value="Within 100 Mtrs from the college">Within 100 Mtrs from the college</option>
                                        </Field>
                                        <ErrorMessage name="parkingProvided" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Upload relevant documentary evidence for Provision of Parking Area (Pdf) </b></label>

                                        <div className='d-flex align-items-center'>
                                            <input type="file" className="form-control" name="parkingAreaDocument" accept="application/pdf"
                                                onChange={(e) => {
                                                    let fileVal = userId + "_" + acYear; let filename = fileVal + "parkingAreaDocument"
                                                    let path = "/Uploads/ParkingDocument/"
                                                    ImagePdfBucket(e, soclandalloFormik, path, "parkingAreaDocument", filename, "pdf")
                                                }} />
                                            {soclandalloFormik.values.parkingAreaDocument && <button type='button' className='ms-2 btn btn-primary'
                                                onClick={() => { viewImage(soclandalloFormik.values.parkingAreaDocument) }}><FaEye size={23} /></button>}

                                            <ErrorMessage name="parkingAreaDocument" component="div" className="text-error" />
                                        </div>

                                    </bie.Col>
                                </bie.Row>
                            </bie.Row>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className=""> Biometric system of attendance</h1></div>

                            <bie.Row className="px-2 pt-3 m-0 ">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Whether Bio metric system is adopted for all students (both UG & PG)</b></label>
                                        <div className='form-control mb-2'>
                                            <Field type="radio" name="biometricAdoptedForStudentsUgPg" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="biometricAdoptedForStudentsUgPg" value="false" />&nbsp; No
                                            <ErrorMessage name="biometricAdoptedForStudentsUgPg" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Whether Bio metric system is adopted for all staff (both Teaching & Non-Teaching)</b></label>

                                        <div className='form-control mb-2'>
                                            <Field type="radio" name="biometricAdoptedForTeachingNon" value="true" />&nbsp;Yes&emsp;
                                            <Field type="radio" name="biometricAdoptedForTeachingNon" value="false" />&nbsp; No
                                            <ErrorMessage name="biometricAdoptedForTeachingNon" component="div" className="text-error" />
                                        </div>
                                    </bie.Col>
                                </bie.Row>
                            </bie.Row>
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="mb-0">Other Facilities</h1></div>

                            <bie.Row className="px-2 pt-3 m-0">
                                <bie.Row>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Total Approved Intake</b></label>

                                        <Field type='text' name="totalintake" className='form-control mb-2' disabled={true} />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Number of Toilets Provided </b></label>

                                        <Field type='text' name="noToiletsProvided" className='form-control mb-2' maxLength="3"
                                            onPaste={(e) => handlePaste(e)} onKeyPress={(e) => { allowNumbersOnly(e) }} onKeyUp={(e) => { CalculateTotalIntake(e?.target?.value) }} />

                                        <ErrorMessage name="noToiletsProvided" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Are separate Toilets provided for Female students</b></label><br />

                                        <Field type="radio" name="separateFemaleToilets" value="true" />    Yes &emsp;
                                        <Field type="radio" name="separateFemaleToilets" value="false" />&nbsp; No
                                        <ErrorMessage name="separateFemaleToilets" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                        <label className='mb-1' ><b className='field-mandatory'>Approved Intake / Number of Toilets </b></label>
                                        <Field type='text' name="noToilets" className='form-control mb-2' maxLength="5"
                                            disabled="true" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                        <label className='mb-1' ><b className='field-mandatory'>Is Girls common Room provided in the college  </b></label><br />
                                        <Field type="radio" name="girlsCommonroom" value="true" />      Yes    &emsp;
                                        <Field type="radio" name="girlsCommonroom" value="false" /> No
                                        <ErrorMessage name="girlsCommonroom" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                            </bie.Row>
                            <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>Submit</button>

                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>
        </>
    )
}
